import { toastrStyles, portfolioButtonStyles } from '../../../styles';

export default theme => ({
  ...portfolioButtonStyles(theme),
  ...toastrStyles(theme),
});
